import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { EntityService, CollectionManagerService } from '@zerops/zef/entities';
import { AppState, ApiEntityKeys } from '@zerops/zerops/app';
import { ZefWebsocketService } from '@zerops/zef/websocket';
import {
  IntegrationTokenDelegation,
  IntegrationTokenDelegationRequest
} from '@zerops/models/integration-token';

@Injectable({ providedIn: 'root' })
export class IntegrationTokenDelegationEntity
  extends EntityService<IntegrationTokenDelegation, IntegrationTokenDelegationRequest> {
  constructor(
    public store: Store<AppState>,
    public collectionManager: CollectionManagerService,
    public websocketService: ZefWebsocketService
  ) {
    super(ApiEntityKeys.IntegrationTokenDelegation, store, collectionManager, websocketService);
  }
}
